"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var Checkbox_1 = require("@material-ui/core/Checkbox");
var FormControlLabel_1 = require("@material-ui/core/FormControlLabel");
var Grid_1 = require("@material-ui/core/Grid");
var Link_1 = require("@material-ui/core/Link");
var Typography_1 = require("@material-ui/core/Typography");
var CardList_1 = require("src/bookstore/CardList");
var Snackbar_1 = require("src/Snackbar");
var react_router_1 = require("react-router");
var CurrentUser_1 = require("src/CurrentUser");
var Routing_1 = require("src/Routing");
var BookshelfCard_1 = require("./BookshelfCard");
var findActiveBlackout_1 = require("./findActiveBlackout");
exports.SearchBookshelfGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nquery BookshelfSearch ($searchParameters: BookSearchParametersInput!){\n  searchBooks (searchParameters: $searchParameters) {\n    ...BookCardFragment\n  }\n}\n", "\n"], ["\nquery BookshelfSearch ($searchParameters: BookSearchParametersInput!){\n  searchBooks (searchParameters: $searchParameters) {\n    ...BookCardFragment\n  }\n}\n", "\n"])), BookshelfCard_1.BookCardFragmentGQL);
/**
 * Use the BookshelfCard component to render cardlist items
 */
var renderBookshelfCard = function (loggedInUser) { return function (book) {
    var blackout = findActiveBlackout_1.default(book, loggedInUser);
    return React.createElement(BookshelfCard_1.default, { book: book, blackout: blackout });
}; };
var keyForBookCard = function (book) { return String(book.id); };
/**
 * Render Cardlist with queried bookshelf content
 */
var BookshelfPage = /** @class */ (function (_super) {
    __extends(BookshelfPage, _super);
    function BookshelfPage(props) {
        var _this = _super.call(this, props) || this;
        _this.limitToShelfChanged = function (e) {
            var loggedInUser = _this.props.currentUser.loggedInUser;
            if (loggedInUser === null) {
                return null;
            }
            var limitToOwned = !(loggedInUser.isRowanUser && e.target.checked === false);
            _this.refetch &&
                _this.refetch({ searchParameters: { isOnShelf: true, limitToOwned: limitToOwned } });
        };
        _this.redirectIfNotLoggedIn(props);
        return _this;
    }
    BookshelfPage.prototype.render = function () {
        var _this = this;
        this.redirectIfNotLoggedIn(this.props);
        var loggedInUser = this.props.currentUser.loggedInUser;
        if (loggedInUser === null) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            loggedInUser.isRowanUser && (React.createElement(Grid_1.default, { container: true },
                React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, { onChange: this.limitToShelfChanged, defaultChecked: false, color: "primary" }), label: "Limit to Bookshelf" }))),
            React.createElement(react_apollo_1.Query, { query: exports.SearchBookshelfGQL, fetchPolicy: "no-cache", variables: {
                    searchParameters: {
                        isOnShelf: true,
                        limitToOwned: loggedInUser.isRowanUser ? false : undefined
                    }
                } }, function (_a) {
                var loading = _a.loading, error = _a.error, data = _a.data, refetch = _a.refetch;
                _this.refetch = refetch;
                if (loading) {
                    return React.createElement(Typography_1.default, { variant: "h3" }, "Loading Bookshelf...");
                }
                if (error) {
                    return React.createElement(Snackbar_1.CustomSnackbar, { variant: "error", message: error.message });
                }
                if (data === undefined) {
                    return React.createElement(Typography_1.default, { variant: "h3" }, "Unable to find any bookshelf items");
                }
                if (data.searchBooks.length === 0) {
                    return (React.createElement(Typography_1.default, { variant: "h3" },
                        React.createElement(Link_1.default, { component: Routing_1.RouterLink('/products'), color: "primary" }, "Shop"),
                        " to add books to your library."));
                }
                return (React.createElement(CardList_1.CardList, { items: data.searchBooks, listItem: renderBookshelfCard(loggedInUser), keyForItem: keyForBookCard }));
            })));
    };
    /**
     * Redirect to login if the user isn't logged in
     */
    BookshelfPage.prototype.redirectIfNotLoggedIn = function (props) {
        var currentUser = props.currentUser, history = props.history;
        if (currentUser.loading === false && !currentUser.loggedInUser) {
            history.push('/login/');
        }
    };
    return BookshelfPage;
}(React.Component));
/**
 * Show bookshelf if there is a logged in user, otherwise redirects to shop page
 */
exports.default = react_router_1.withRouter(CurrentUser_1.withCurrentUser(BookshelfPage));
var templateObject_1;
